import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PieChart, ChartConfig } from '../revoreporting/AmChartWrapper';
import { XYChart2Lines } from './XYChart2Lines';
import { ARequestVM } from "../revoreporting/Api";
import DatePicker from 'vuejs-datepicker';
import VueSelect from 'vue-select'; // needed for multiselect not ported yet
import 'vue-select/dist/vue-select.css' // import css
import moment from 'moment'
import 'jquery'
import $ from 'jquery';
import { Cell } from '../backend/backendapi';

@Component(
    {
        name: 'reportcells',
        components: {
            DatePicker,
            VueSelect,
        }
    })
export default class ReportCellsComponent extends Vue {
    //refs needed to access elements from template
    $refs!: {
        chartdiv: HTMLDivElement,
        piediv: HTMLDivElement
    }
    //startOfMonth: string = moment().clone().startOf('month').format('YYYY-MM-DD hh:mm');
    //endOfMonth: string = moment().clone().endOf('month').format('YYYY-MM-DD hh:mm');
    startOfDay: Date = moment().clone().startOf('day').toDate();
    endOfDay: Date = moment().clone().startOf('day').add('day', 1).toDate();

    start: Date = this.startOfDay;
    end: Date = this.endOfDay;
    chart: XYChart2Lines | undefined;
    chart2: PieChart | undefined;
    cells: Cell[] = [];
    fKCellId: number = 1;
    id: number = 0;

    //configure chart here
    mounted() {
        this.id = moment().hour()+moment().minute();
        this.fetchcells();

        let request = new ARequestVM();
        request.Route = "lineOee";
        request.startDate = this.start;
        request.endDate = this.end;
        request.addSingleEntityFilter("id=" + this.fKCellId);

        this.chart = new XYChart2Lines(this.$refs.chartdiv);
        let config = new ChartConfig();
        config.vAxisMin = 0;
        config.vAxisMax = 1;
        config.strictMinMax = true;
        this.chart.setConfig(config);
        this.chart.requestVM = request;

        this.chart.setFetchApi('reportingapi');
        //this.chart.fetchData();

        let request2 = new ARequestVM();
        request2.Route = "pieChartOee";
        request2.startDate = this.start;
        request2.endDate = this.end;
        this.chart2 = new PieChart(this.$refs.piediv);
        this.chart2.requestVM = request2;
        this.chart2.setFetchApi('reportingapi');
        //this.chart2.fetchData();

        $('.cssload-loader').hide(); // spinner here https://icons8.com/cssload/en/spinners/
    }
    onClick(selectedDate: Date) {
        console.log("datetime clicked date=" + selectedDate);
        var min = (new Date).getTimezoneOffset();
        var nextDay = new Date(selectedDate);
        nextDay.setDate(nextDay.getDate() + 1);
        this.end = nextDay;
        this.start = selectedDate; // use UTC, convert on backend

        let request = new ARequestVM();
        request.Route = "lineOee";
        request.startDate = selectedDate;
        request.endDate = this.end;
        request.offsetMin = min;
        request.addSingleEntityFilter("id=" + this.fKCellId);

        let request2 = new ARequestVM();
        request2.Route = "pieChartOee";
        request2.startDate = selectedDate;
        request2.endDate = this.end;
        request2.offsetMin = min;
        request2.addSingleEntityFilter("id=" + this.fKCellId);
        if (this.chart !== undefined && this.chart2 !== undefined) {
            $('.cssload-loader').show();
            this.chart.requestVM = request;
            this.chart.fetchData();
            this.chart2.requestVM = request2;
            this.chart2.fetchData();
        }
        $('.cssload-loader').hide();
    }

    onClickEnd(selectedDate: Date) {
        console.log("datetime end clicked date=" + selectedDate);
        var min = (new Date).getTimezoneOffset();
        //var startDay = moment(this.start).add("minutes", 60).toDate();
        let request = new ARequestVM();
        request.Route = "lineOee";
        request.startDate = this.start;
        request.endDate = selectedDate;;
        request.offsetMin = min;
        request.addSingleEntityFilter("id=" + this.fKCellId);

        let request2 = new ARequestVM();
        request2.Route = "pieChartOee";
        request2.startDate = this.start;
        request2.endDate = selectedDate;
        request2.offsetMin = min;
        request2.addSingleEntityFilter("id=" + this.fKCellId);
        if (this.chart !== undefined && this.chart2 !== undefined) {
            $('.cssload-loader').show();
            this.chart.requestVM = request;
            this.chart.fetchData();
            this.chart2.requestVM = request2;
            this.chart2.fetchData();
        }
        $('.cssload-loader').hide();

    }

    fetchcellsServ(): Promise<Cell[]> {
        return fetch('api/cell/cells')
            .then(response => response.json() as Promise<Cell[]>);
    }
    fetchcells() {
        this.fetchcellsServ()
            .then(data => {
                this.cells = data as Cell[];
            });
    }

}
